import { render } from "./TicTacToe.vue?vue&type=template&id=2ed09d3f"
import script from "./TicTacToe.vue?vue&type=script&lang=js"
export * from "./TicTacToe.vue?vue&type=script&lang=js"

import "./TicTacToe.vue?vue&type=style&index=0&id=2ed09d3f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__